import * as React from 'react';

import cx from 'classnames';

import { FocusIndicator } from '~shared/components/FocusIndicator/FocusIndicator';
import warning from '~shared/utils/warning';

import { TabPanelsContext } from './TabPanels';
import { TabsContext } from './TabsProvider';

export interface TabPanelProps {
  children: React.ReactNode;
}

/**
 * @deprecated Use the TabsV2 components instead.
 */
export function TabPanel({ children }: TabPanelProps) {
  const tabsContext = React.useContext(TabsContext);
  const tabPanelsContext = React.useContext(TabPanelsContext);

  warning(
    tabsContext !== null,
    'A TabPanel must be rendered as a child of TabsProvider'
  );

  if (!tabPanelsContext) {
    throw new Error('TabPanel rendered outside TabPanels');
  }

  if (!tabsContext) {
    throw new Error('TabPanel rendered outside TabsProvider');
  }

  const { a11y, selectedIndex } = tabsContext;
  const { panelIndex } = tabPanelsContext;
  const isSelected = panelIndex === selectedIndex;

  const panelClass = React.useMemo(
    () =>
      cx('relative h-full outline-none', 'tabs-panel', {
        hidden: !isSelected,
      }),
    [isSelected]
  );

  return (
    <div
      className={panelClass}
      {...a11y.tabPanelProps({ panelIndex, isSelected })}
    >
      {isSelected ? children : undefined}
      <FocusIndicator notOffset isInset />
    </div>
  );
}
